
import { Component, Vue, Prop } from "vue-property-decorator";
import {createBrand} from "@/api/brand";

@Component({
  name: "createBrand"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "创建品牌" }) private title: "";
  @Prop({ default: "" }) private customerId: "";

  private submitLoading = false;
  public info = {} as any;
  public infoFields2 = [
    {
      label: "品牌名称",
      key: "name",
      type: "input",
      maxLength: 64,
    }
  ] as any;

  private close() {
    this.info = {};
    this.$emit("update:show", false);
  }
  // 创建品牌：点击确认
  private async submitForm(): Promise<void> {
    this.submitLoading = true;
    if (this.customerId === "") {
      console.error("父子组件传递出现了问题");
    }
    await createBrand(this.customerId, this.info.name)
    .then(() =>{
      this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000
    });
    this.info = {};
      this.$emit("success");
    })
    .catch((err) => {
      console.log(err);
    })
    this.submitLoading = false;
  }
}
